<template>
  <div class="h-400px overflow-y-auto pa-1">
    <v-card
      v-for="produto in produtos_combinados"
      :key="produto.id_produto_combinado"
      class="mb-3 z-999"
    >
      <div class="d-flex align-center pa-2" :style="{background: selecaoFornecedorValida(produto) ? '#E8F5E9' : '#FFEBEE'}">
        <v-btn icon @click="produto.expandido = ! produto.expandido">
          <v-icon v-if="produto.expandido">mdi-chevron-down</v-icon>
          <v-icon v-else>mdi-chevron-right</v-icon>
        </v-btn>
        <span class="font-weight-medium font-15 text-gray-1000">{{ produto.descricao }}</span>

        <v-spacer />

        <v-icon v-if="selecaoFornecedorValida(produto)" color="green">mdi-check-circle</v-icon>
        <v-icon v-else color="red">mdi-close-circle</v-icon>
      </div>

      <div
        v-if="produto.expandido"
        v-for="fornecedor in produto.fornecedores"
        :key="fornecedor.idfornecedor"
        class="pl-5"
      >
        <v-btn icon @click="produto.fornecedores.forEach(item => item.selecionado = false);selecionarFornecedor(fornecedor)">
          <v-icon v-if="fornecedor.selecionado" color="primary">mdi-checkbox-marked</v-icon>
          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <span
          class="font-14 text-gray-400"
          :class="{'text-gray-900 font-weight-bold': String(props.idfornecedor_pedido) === String(fornecedor.idfornecedor)}"
        >
          {{ `${fornecedor.idfornecedor} - ${fornecedor.razao_social}` }}
        </span>
      </div>
    </v-card>

    <SysDialog v-if="fornecedor_por_selecionar_produtos" v-model="dialog_selecao_produtos_fornecedor_ativo">
      <template #titulo>
        <div class="w-full">
          <p v-text="'Marca com múltiplos produtos'" class="ma-0 font-24" />
          <p class="font-12 font-weight-regular mt-n2 ma-0">
            Selecione os produtos que deseja comprar da marca
            <span class="font-weight-medium">{{ fornecedor_por_selecionar_produtos.razao_social }}</span>
          </p>
        </div>
      </template>

      <div class="mt-n3">
        <div
          v-for="produto in fornecedor_por_selecionar_produtos.produtos"
          :key="produto.idproduto"
          class="pl-2"
        >
          <v-btn icon @click="fornecedor_por_selecionar_produtos.produtos.forEach(item => item.selecionado = false);produto.selecionado = ! produto.selecionado;">
            <v-icon v-if="produto.selecionado" color="primary">mdi-checkbox-marked</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-btn>
          <span class="font-14 text-gray-400">{{ `${produto.idproduto} - ${produto.descricao_produto}` }}</span>
        </div>
      </div>

      <template #actions>
        <v-btn
          text
          color="primary"
          :disabled="!fornecedor_por_selecionar_produtos.produtos.some(prod => prod.selecionado)"
          @click="dialog_selecao_produtos_fornecedor_ativo = ! dialog_selecao_produtos_fornecedor_ativo"
        >
          confirmar
        </v-btn>
      </template>
    </SysDialog>
  </div>
</template>

<script setup>
import {ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

const props = defineProps({
  produtos_combinados: Array,
  idfornecedor_pedido: Number,
});

const dialog_selecao_produtos_fornecedor_ativo = ref(false);
const fornecedor_por_selecionar_produtos = ref(null);

function selecaoFornecedorValida(produto) {
  const callback = item => item.selecionado && (item.produtos.length === 1 || (item.produtos.length > 1 && item.produtos.some(item => item.selecionado)));
  return produto.fornecedores.some(callback);
}

function selecionarFornecedor(fornecedor) {
  fornecedor.selecionado = ! fornecedor.selecionado;

  if (fornecedor.selecionado) {
    if (fornecedor.produtos.length === 1) {
      fornecedor.produtos.forEach(produto => produto.selecionado = true);
    } else {
      fornecedor_por_selecionar_produtos.value = fornecedor;
      dialog_selecao_produtos_fornecedor_ativo.value = true;
    }
  }
}
</script>
